"use client";
import { _ as CollapsibleRoot$1, g as CollapsibleTrigger$1, h as CollapsiblePanel$1 } from "../chunks/vendor-base-ui-n0ony04mhklkmnfd.js";
import { t as cn } from "../chunks/cn-dk9nmc4mhy1765ud.js";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/collapsible/collapsible.tsx
var ATOMS_COLLAPSIBLE_VARIANTS = {};
var ATOMS_COLLAPSIBLE_DEFAULT_VARIANTS = {};
function collapsibleVariants(_props = {}) {
	return cn();
}
function CollapsibleRoot({ className, ...props }) {
	return /* @__PURE__ */ jsx(CollapsibleRoot$1, {
		className,
		...props
	});
}
CollapsibleRoot.displayName = "Collapsible.Root";
var CollapsibleTrigger = forwardRef(({ className, ...props }, ref) => {
	return /* @__PURE__ */ jsx(CollapsibleTrigger$1, {
		ref,
		className: cn("cursor-pointer", className),
		...props
	});
});
CollapsibleTrigger.displayName = "Collapsible.Trigger";
var CollapsiblePanel = forwardRef(({ className, ...props }, ref) => {
	return /* @__PURE__ */ jsx(CollapsiblePanel$1, {
		ref,
		className,
		...props
	});
});
CollapsiblePanel.displayName = "Collapsible.Panel";
/**
* Compound component for show/hide disclosure regions. Use it for expandable
* sections, FAQ entries, or any content that toggles open and closed.
*
* Compose it from its sub-components: `Collapsible.Root` (also the default
* export) wraps the region and owns open/close state, `Collapsible.Trigger` is
* the button that toggles it, and `Collapsible.Panel` holds the collapsible
* content. Open state can be controlled (`open` + `onOpenChange`) or
* uncontrolled (`defaultOpen`) via the underlying Base UI props.
*
* @example
* ```tsx
* <Collapsible.Root defaultOpen={false}>
*   <Collapsible.Trigger>Show details</Collapsible.Trigger>
*   <Collapsible.Panel>
*     <p>Hidden content revealed when expanded.</p>
*   </Collapsible.Panel>
* </Collapsible.Root>
* ```
*/
var Collapsible = Object.assign(CollapsibleRoot, {
	Root: CollapsibleRoot,
	Trigger: CollapsibleTrigger,
	Panel: CollapsiblePanel
});
//#endregion
export { ATOMS_COLLAPSIBLE_DEFAULT_VARIANTS, ATOMS_COLLAPSIBLE_VARIANTS, Collapsible, collapsibleVariants };

